import {
  List,
  Divider,
  Box,
  // SwipeableDrawer,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import {
  // closeShoppingCart,
  // openShoppingCart,
  openCheckoutForm,
} from "../redux/giftShoppingCartSlice";
import ShoppingCartItem from "./ShoppingCartItem";
import { setSelectedMarketplaceTab } from "../redux/uiSlice";

interface ShoppingCartProps {}

const ShoppingCart: React.FC<ShoppingCartProps> = () => {
  const { giftBrands, open } = useAppSelector((state) => state.shoppingCart);
  const dispatch = useAppDispatch();

  const calculateTotal = () => {
    return giftBrands
      .reduce((total, item) => total + item.amount * item.quantity, 0)
      .toFixed(2);
  };

  const handleCheckout = () => {
    dispatch(openCheckoutForm());
  };

  return (
    <>
      <Box sx={{ p: 2, textAlign: "start" }}>
        <Typography variant="h6">Shopping Cart</Typography>
      </Box>
      <Divider />
      {giftBrands.length === 0 ? (
        <Box
          sx={{
            textAlign: "center",
            py: 4,
            minHeight: "200px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle1" color="text.secondary">
            Your cart is empty
          </Typography>
          <Button
            variant="outlined"
            onClick={() => dispatch(setSelectedMarketplaceTab("list"))}
          >
            Continue Shopping
          </Button>
        </Box>
      ) : (
        <>
          <List sx={{ pt: 0, flex: 1, overflow: "auto" }}>
            {giftBrands.map((item) => (
              <div key={item.productId}>
                <ShoppingCartItem item={item} />
                <Divider variant="inset" component="li" />
              </div>
            ))}
          </List>

          <Box
            sx={{
              p: 2,
              borderTop: "1px solid",
              borderColor: "divider",
            }}
          >
            <Stack spacing={2}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" fontWeight="bold">
                  Grand Total:
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  ${calculateTotal()}
                </Typography>
              </Box>

              <Button
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                onClick={() => {
                  dispatch(setSelectedMarketplaceTab("checkout"));
                }}
                sx={{
                  py: 1.5,
                  fontWeight: "bold",
                  textTransform: "none",
                  fontSize: "1rem",
                }}
              >
                Proceed to Checkout
              </Button>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                onClick={() => {
                  dispatch(setSelectedMarketplaceTab("list"));
                }}
                sx={{
                  py: 1.5,
                  fontWeight: "bold",
                  textTransform: "none",
                  fontSize: "1rem",
                }}
              >
                Resume Shopping
              </Button>
            </Stack>
          </Box>
        </>
      )}
    </>
  );
};

export default ShoppingCart;
